import React from "react";
import PropTypes from "prop-types";
import find from "lodash/find";
import clone from "lodash/clone";

import { MenuItem } from "@mui/material";
import { Dropdown } from "components/Dropdown";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";

export function MetaKeySelect(props) {
  const { attribute, onAttributeTypeSelected, attributeTypeError } = props;

  const { error: metaTypesError, response: metaTypes } = useFetchGetV2(
    "case_meta_types_expanded"
  );

  const setAttributeType = event => {
    onAttributeTypeSelected({
      ...clone(
        find(metaTypes.results, {
          id: event.target.value
        })
      )
    });
  };

  return (
    <Dropdown
      id="attribute-name-select"
      name="attribute-name-select"
      label="Attribute"
      required
      fullWidth
      value={`${attribute?.id ?? ""}`}
      onChange={setAttributeType}
      data-qa="CM-Select-Attribute-Name"
      error={Boolean(attributeTypeError || metaTypesError)}
      helperText={
        attributeTypeError
          ? attributeTypeError
          : metaTypesError
          ? "Failed to load options"
          : ""
      }
    >
      {metaTypes?.results?.map(x => (
        <MenuItem value={x.id} key={x.id}>
          {x.name}
        </MenuItem>
      )) ?? []}
    </Dropdown>
  );
}

MetaKeySelect.propTypes = {
  attribute: PropTypes.object,
  onAttributeTypeSelected: PropTypes.func,
  attributeTypeError: PropTypes.string
};
